import { useState, useEffect } from "react";
import userSVG from "../../utils/assets/client/user.svg";
import { fetchLeadStatus, fetchLeadDetails, generateEstimate, generateTicket, fetchLeadComments, AddLeadComments, UpdateLead, fetchTaxClass, fetchCustomerGroup } from "../../actions/admin/leads";
import { useParams } from "react-router-dom";
import InvoicePNG from "../../utils/assets/theme_invoice.png";
import DeviceSelection from "../../components/admin/DeviceSelection";
import { fetchDefects } from "../../actions/client/devices";
import GeneralSelectBar from "../../components/admin/GeneralSelectBar";
import InputValue from "../../components/admin/InputValue";
import { toast } from 'react-toastify'
import AdminComments from "../../components/admin/AdminComments";
import {
  fetchDevices
} from "../../actions/client/devices";
const LeadPage = () => {
  const [leadStatus, setLeadStatus] = useState([]);
  const [leadData, setLeadData] = useState({});
  const [updatedLeadsdata, setUpdatedLeadsData]= useState({})
  const [BrandsData, setBrandsData] = useState([]);
  const [defects, setDefects] = useState([]);
  const [leadComments, setLeadComments] = useState([])
  const [taxClass, setTaxClass] = useState([])
  const [customerGroup, setCustomerGroup] = useState([])
  const [leadValue, setLeadValue] = useState({
    lead_value: "",
    tax: ""
  });
  const [allCategories, setCategories] = useState([]);

  const [CustomerDetails, setCustomerDetails] = useState({
    customer_group_id: "",
    tax_class_id: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    driving_license: "",
    shipping_address: ""
  })
  const { id } = useParams();
  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  useEffect(() => {
    const token = localStorage.getItem("token");

    fetchLeadStatus(token).then((res) => {
      setLeadStatus(res.data);
    });
    fetchLeadDetails(token, id).then((res) => {
      setLeadData(res.data);
      setUpdatedLeadsData(res.data)
      setCustomerDetails({
        customer_group_id: res.data.customer.customer_group_id,
        tax_class_id: res.data.customer.tax_class_id,
        first_name: res.data.customer.first_name,
        last_name: res.data.customer.last_name,
        email: res.data.customer.email,
        phone: res.data.customer.phone,
        driving_license: res.data.customer.driving_license,
        shipping_address: res.data.customer.shipping_address
      })
      setLeadValue({
        lead_value: res.data.customer.lead_value,
        tax: res.data.customer.tax
      })
    });
    fetchDefects().then((res) => {
      setDefects(res.data);
    });
    fetchLeadComments(token, id).then((res) => {
      setLeadComments(res.data)
    });
    fetchTaxClass(token).then((res) => {
      setTaxClass(res.data)
    });
    fetchCustomerGroup(token).then((res) => {
      setCustomerGroup(res.data)
    })
    fetchDevices(token).then((response) => {
      setCategories(response.data);
    })


  }, []);
  const CustomerGroupData = [
    {
      id: 1011,
      title: "Retail",
    },
    {
      id: 1220,
      title: "Trade",
    },
    {
      id: 1109,
      title: "Individual",
    },
  ];
  const generateEstimateEvent = () => {
    const token = localStorage.getItem("token");
    generateEstimate(id, token).then((res) => {
      toast.success("Estimate created successfully!")
    })
  }
  const generateTicketEvent = () => {
    const token = localStorage.getItem("token");
    generateTicket(id, token).then((res) => {
      toast.success("Ticket created successfully!")
    })
  }
  const checkStatus = (item) => {
    return updatedLeadsdata && updatedLeadsdata.lead_items ? item.title === updatedLeadsdata.lead_items[0].status : 'New';
  }
  const getFormattedDate = () => {
    console.log('leadData.created_at', leadData.created_at)
    return leadData.created_at ? leadData.created_at.split("T")[0] : new Date().toISOString().split("T")[0];
  }
  const handleTaskSubmit = () => {};



  const handleComments = async (note, boolValue) => {
    const token = localStorage.getItem("token");

    const data = {
      "lead_item_id": id,
      note,
      "is_internal": boolValue
    }

    await AddLeadComments(token, data).then((res) => {
      if(res.success == true){
        toast.success("Note Added Successfully")
        fetchLeadComments(token, id).then((res) => {
          setLeadComments(res.data)
        })
      }else{
        toast.error("Something went wrong")

      }
    })


  }

  const handleUpdate = () => {
    const token = localStorage.getItem("token");
    const dataSet = {
      ...updatedLeadsdata,
      customer: CustomerDetails
    }
    dataSet["lead_items"].forEach((leads) => {
      const statusDetais = leadStatus.find((itm) => itm.title == leads.status || itm.id == leads.status);
      leads.status = statusDetais.id;
      delete leads.created_at;
      delete leads.updated_at;
      delete leads.brand.created_at;
      delete leads.brand.updated_at;
      delete leads.category.created_at;
      delete leads.category.updated_at;
      leads.defects.forEach((defect) => {
        delete defect.created_at;
        delete defect.updated_at;
      });
      leads.devices.forEach((devices) => {
        delete devices.created_at;
        delete devices.updated_at;
      });
    });
    delete dataSet.created_at;
    delete dataSet.customer.created_at;
    delete dataSet.user.created_at;
    delete dataSet.updated_at;
    delete dataSet.customer.updated_at;
    delete dataSet.user.updated_at;
    
    console.log('CustomerDetails', CustomerDetails)
    console.log('updatedLeadsdata', updatedLeadsdata)
    UpdateLead(token, dataSet).then((res) => {
        if(res.success === true){
          toast.success("Lead Successfully Updated")
        }else{
          toast.error("Something went wrong")
        }
        console.log("uptygsxvwdghvchdw", res);
    })
    
  }

  const updateLeadValue = (leadItemId, newValue) => {
    setUpdatedLeadsData((prevState) => ({
      ...prevState,
      lead_items: prevState.lead_items.map((item) =>
        item.id === leadItemId
          ? {
              ...item,
              lead_value: newValue,
            }
          : item
      ),
    }));
  };
  const updateLeadStatus = (e) => {
    updatedLeadsdata.lead_items.forEach((lead) => {
      const statusDetais = leadStatus.find((itm) => itm.title == e.target.value || itm.id == e.target.value);
      lead.status = statusDetais.id;
    });
    setUpdatedLeadsData({...updatedLeadsdata})
  }
  const updateCategorySelection = (e) => {
    console.log('e', e)
    updatedLeadsdata.lead_items.forEach((lead) => {
      lead.category = e;
      lead.category_id = e.id;
    });
    setUpdatedLeadsData(updatedLeadsdata)
  }
  const updateDeviceSelection = (e) => {
    console.log('e', e)
    updatedLeadsdata.lead_items.forEach((lead) => {
      lead.devices = [e];
    });
    console.log('updatedLeadsdata.lead_items', updatedLeadsdata.lead_items)
    setUpdatedLeadsData(updatedLeadsdata)
  }
  const updateTaskSelection = (e) => {
    console.log('e', e)
    updatedLeadsdata.lead_items.forEach((lead) => {
      lead.defects = [e];
    });
    console.log('updatedLeadsdata.lead_items', updatedLeadsdata.lead_items)
    setUpdatedLeadsData(updatedLeadsdata)
  }
  


console.log("lead_value", updatedLeadsdata);
  return (
    <div className="bg-light">
      <div className="mx-3 mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="text-black my-3">Lead #{leadData.lead_id}</h3>
          <div className="d-flex ">
            <button className="btn  bg-black text-white py-2 px-4 mx-2"  onClick={() => handleUpdate()}>Save</button>
            <button className="btn  bg-black text-white py-2 px-4" onClick={generateEstimateEvent}>Create Estimate</button>
            <button className="btn  bg-black text-white mx-2 py-2 px-4" onClick={generateTicketEvent}>
              Convert to Ticket
            </button>
          </div>
        </div>
        <div className="row d-flex ">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
            <div className=" bg-white card_radius">
              <div className="px-3 pt-3 d-flex justify-content-start align-items-center">
                <div className="profile_div bg-white">
                  <img
                    src={userSVG}
                    alt=""
                    className="p-1"
                    style={{ width: "inherit" }}
                  />
                </div>
                <div className="px-3">
                  <span className=" f-24">
                    {leadData?.customer?.first_name } {leadData?.customer?.last_name}
                  </span>
                </div>
              </div>
              <div className="px-3">
                <hr />
              </div>

              <div className="row px-3 d-flex justify-content-center align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">
                    Customer Group
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setCustomerDetails({...CustomerDetails, customer_group_id: e.target.value})}

                  >
                    <option selected>Select Item</option>
                    {customerGroup && customerGroup.map((item) => {
                      return (
                        <option key={item.id} selected={leadData?.customer?.customer_group_id === item.id} value={item.id}>
                          {item.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Tax Class</label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setCustomerDetails({...CustomerDetails, tax_class_id: e.target.value})}
                  >
                    {
                      taxClass && taxClass.map((item) => {
                        return (
                          <option key={item.id} value={item.id}  selected={leadData?.customer?.tax_class_id === item.id}>{item.name}</option>

                        )
                      })
                    }
                  </select>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">First Name</label>
                  <input
                    type="text"
                    value={CustomerDetails.first_name}
                    onChange={(e) => setCustomerDetails({...CustomerDetails, first_name: e.target.value})}
                    className="form-control"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Last Name</label>
                  <input
                    type="text"
                    value={CustomerDetails.last_name}
                    onChange={(e) => setCustomerDetails({...CustomerDetails, last_name: e.target.value})}
                    className="form-control"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Email</label>
                  <input
                    type="text"
                    value={CustomerDetails.email}
                    onChange={(e) => setCustomerDetails({...CustomerDetails, email: e.target.value})}

                    className="form-control"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">
                    Phone Number
                  </label>
                  <input
                    type="text"
                    value={CustomerDetails.phone}
                    onChange={(e) => setCustomerDetails({...CustomerDetails, phone: e.target.value})}
                    className="form-control"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <label className="form-label ">
                    Driving License
                  </label>
                  <input
                    type="text"
                    value={updatedLeadsdata && updatedLeadsdata.customer ? updatedLeadsdata.customer.driving_license : ''}
                    onChange={(e) => setUpdatedLeadsData({...updatedLeadsdata, customer: {...updatedLeadsdata.customer, driving_license: e.target.value}})}
                    className="form-control"
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <label className="form-label ">
                    Shipping Address
                  </label>
                  <input
                    type="text"
                    value={updatedLeadsdata && updatedLeadsdata.customer ? updatedLeadsdata.customer.shipping_address : ''}
                    onChange={(e) => setUpdatedLeadsData({...updatedLeadsdata, customer: {...updatedLeadsdata.customer, shipping_address: e.target.value}})}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div className="bg-white card_radius">
              <div className="px-3 pt-3 d-flex justify-content-start align-items-center">
                <div className="profile_div bg-white">
                  <img
                    src={InvoicePNG}
                    alt="invoice"
                    className="p-1"
                    style={{ width: "inherit" }}
                  />
                </div>

                <div className="px-3">
                  <span className="text-black f-24">Lead Summary</span>
                </div>
              </div>
              <div className="px-3">
                <hr />
              </div>
              <div className="row px-3 d-flex justify-content-center align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">
                    Lead Status
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => updateLeadStatus(e)}
                  >
                    <option>Select Item</option>
                    {leadStatus.map((item) => {
                      return (
                        <option selected={checkStatus(item)} key={item.id} value={item.title}>
                          {item.title}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">
                    Assigned To
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    value={leadData.assigned_to}
                  >
                    <option selected>Assigned to</option>
                    <option value={"Vat"}>ACI</option>
                    <option value={"Tax Exempt"}>Hiren</option>
                  </select>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Created on</label>
                  <input type="date" className="form-control" value={getFormattedDate} />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Location</label>
                  <input type="text" className="form-control" />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <label className="form-label ">
                    Last Modified
                  </label>
                  <input type="text" className="form-control" />
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <label className="form-label ">
                    Referral Source
                  </label>
                  <input type="text" className="form-control" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-3 mx-4">
        <div className="row border_bg_col overflow-hidden">
          <p className="txt-head bg-black px-3 text-white mb-0  p-2">Device Details</p>
          <table className="table table-bordered table-striped table-hover mb-0 mt-0">
            <thead>
              <tr className="p-2">
                <td>Repair Category</td>
                <td>Device</td>
                <td>Task</td>
                <td>Color</td>
                <td>IMEI/Serial</td>
                <td>Type</td>
                <td>Time Slot From</td>
                <td>Time Slot To</td>
                <td>Lead Value</td>
                <td>Tax</td>
                <td>Actions</td>
              </tr>
            </thead>
            <tbody>
              {updatedLeadsdata.lead_items
                ? updatedLeadsdata.lead_items.map((item) => {
                    return (
                      <tr className="p-3" key={item.id}>
                        <td>
                          <GeneralSelectBar
                            dataset={allCategories}
                            name={item.category.name}
                            onValueChange={(e) => updateCategorySelection(e)}
                          />
                        </td>
                        <td>
                          <DeviceSelection
                            name={item?.devices[0].title}
                            id={item?.devices[0].category_id}
                            onValueChange={(e) => updateDeviceSelection(e)}
                          />
                        </td>
                        <td className="">
                          <GeneralSelectBar
                            dataset={defects}
                            name={item.defects[0].title}
                            onValueChange={(e) => updateTaskSelection(e)}
                          />{" "}
                        </td>
                        <td>{item?.color || "-"}</td>
                        <td>

                          {
                            item.imei_no ? ( 
                              <>
                          <InputValue value={item.imei_no} />

                              </>
                            ) : (
                          <InputValue value={item.serial_no} />

                            )
                          }
                        </td>
                        <td>{item?.delivery_type ? toTitleCase(item?.delivery_type) : '-'}</td>
                        <td>{item?.time_from ? item?.time_from : 'N/A'}</td>
                        <td>{item?.time_to ? item?.time_to : 'N/A'}</td>
                        <td>
  <input
    type="text"
    inputMode="numeric"
    value={item.lead_value}
    onChange={(e) => {
      const input = e.target.value;
      if (/^\d*\.?\d*$/.test(input)) {
        const newLeadValue = parseFloat(input) || 0;
        const tax = (newLeadValue * 0.18).toFixed(2);

        setUpdatedLeadsData((prevState) => ({
          ...prevState,
          lead_items: prevState.lead_items.map((leadItem) =>
            leadItem.id === item.id
              ? {
                  ...leadItem,
                  lead_value: input,
                  tax: tax,
                }
              : leadItem
          ),
          estimates: {
            ...prevState.estimates,
            total_tax: prevState.lead_items
              .map((li) =>
                li.id === item.id ? parseFloat(tax) : parseFloat(li.tax || 0)
              )
              .reduce((acc, curr) => acc + curr, 0)
              .toFixed(2),
          },
        }));
      }
    }}
    className="form-control form-control-sm"
  />
</td>
<td>
  <input
    readOnly
    className="form-control form-control-sm"
    value={
      updatedLeadsdata?.lead_items?.find((leadItem) => leadItem.id === item.id)
        ?.tax || "0.00"
    }
  />
</td>

                        <td>Refferal</td>
                      </tr>
                    );
                  })
                : ""}
              
            </tbody>
          </table>
        </div>
      </div>

      <div className="my-3 mx-4">
        <AdminComments notesData={leadComments} submit={handleComments} header={"Lead History"} />
      </div>
    </div>
  );
};

export default LeadPage;
